const TIMEOUT_SYMBOL = Symbol('timeout');

export async function withTimeout<TResult>(promise: Promise<TResult>, timeoutMillis: number): Promise<TResult> {
    const result = await withTimeoutResult(promise, timeoutMillis);
    if (result.timeout) {
        throw new PromiseTimeoutError(timeoutMillis);
    }
    return result.value;
}

export type TimeoutResult<TResult> = {timeout: true} | {timeout: false, value: TResult};

export class PromiseTimeoutError extends Error {
    constructor(ms: number) {
        super(`Promise timed out after ${ms} ms`);
    }
}

async function withTimeoutResult<TResult>(promise: Promise<TResult>, ms: number): Promise<TimeoutResult<TResult>> {
    const timeoutPromise = new Promise<typeof TIMEOUT_SYMBOL>(resolve => {
        setTimeout(() => {
            resolve(TIMEOUT_SYMBOL);
        }, ms);
    });

    const raceResult = await Promise.race([promise, timeoutPromise]);

    if (raceResult === TIMEOUT_SYMBOL) {
        return { timeout: true };
    }

    return { timeout: false, value: raceResult };
}
